export enum NotificationType {
  TABLE_CALL = 20, // Waiter Call (NotificationTypeTableCall)
  BILL_REQUEST = 30, // Bill Request (NotificationTypeBillRequest)
}
